export default __webpack_public_path__ + "static/media/CivilEng_IMG-Earthworks.d1a3bcb9.png";